import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
import NotificationCard from '../../components/NotificationCard';

const EVENT_CLICK = `click`;

const SELECTOR_CONTAINER = '.lta-notification-container';
const SELECTOR_DATA = '.lta-notification-container__data';
const SELECTOR_VIEW_MORE = '.lta-notification-container__viewmore';
const SELECTOR_COUNT = '.lta-notification-container__count';

const CHUNK_SIZE = 5;

class SelfSubmissionNotification {
	constructor() {
		this.init();
		this._data = [];
		this.loaded = 0;
		this.totalNotificationCount = 0;
	}

	init() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_CONTAINER);
		if (!this._wrapper) {
			return;
		}
		this.notificationList = SelectorEngine.findOne(SELECTOR_DATA, this._wrapper);
		this.viewmoreButton = SelectorEngine.findOne(SELECTOR_VIEW_MORE, this._wrapper);
		this.notificationCountElement = SelectorEngine.findOne(SELECTOR_COUNT, this._wrapper);

		this.redirectUrl = Manipulator.getDataAttribute(this._wrapper, 'redirectUrl');

		if (!this._wrapper) {
			return;
		}
		this.contactId = Manipulator.getDataAttribute(this._wrapper, 'contactId');
		EventHandler.on(this.viewmoreButton, EVENT_CLICK, () => {
			this.loadChunk();
		});
		this.fetchCount();
	}

	set data(data) {
		this._data = data;
		this.render();
	}

	get data() {
		return this._data || [];
	}

	async fetchCount() {
		try {
			const response = await Request.get(`/api/selfsubmission/getNotifications?contactId=${this.contactId}`);
			// const response = await fetch(`http://dev-verolt.azurewebsites.net/api/selfsubmission/getNotifications?contactId=0038E00001LABbUQAX`);

			if (response.error.errorcode == '00') {
				this.updateCount(response.response?.matches?.length, response.response.matches);
			}
		} catch (error) {
			if (error.error.errorcode == '00') {
				this.updateCount(error.response?.matches?.length, error.response.matches);
			}
			if (error.error.errorcode == '99') {
				console.log(error.error.errormessage);
			}
		}
	}

	updateCount(count = 0, matches = []) {
		this.totalNotificationCount = Number.isNaN(count) ? 0 : count;
		this.remaining = count;
		this.matches = matches;
		if (this.notificationCountElement) {
			this.notificationCountElement.innerHTML = this.totalNotificationCount > 1 ?
				`${this.totalNotificationCount} Notifications` :
				`${this.totalNotificationCount} Notification`;
		}
		this.loadChunk();
	}

	manageViewMore() {
		if (!this.viewmoreButton) { return }
		if (this.remaining > 0) {
			this.viewmoreButton.classList.remove('u-hidden');
		} else {
			this.viewmoreButton.classList.add('u-hidden');
		}
	}

	loadChunk() {
		const newChunk = Array.from({ length: this.remaining > CHUNK_SIZE ? CHUNK_SIZE : this.remaining })
			.map((__, index) => ({
				matchId: this?.matches[this.data.length + index]?.id,
				title: this?.matches[this.data.length + index]?.description,
				tagLabel: 'MATCH REQUEST',
				tagLabelPrefix: '•',
				tagType: 'warning',
				date: new Date(this?.matches[this.data.length + index]?.createdDate)?.toLocaleDateString("en-UK")
			}));

		this.data = [
			...this.data,
			...newChunk
		];
		this.remaining = this.totalNotificationCount - this.data.length;
		this.manageViewMore();
	}

	render() {
		const notificationRenderData = this.data.map((data) => this.renderNotificationRow(data)).join('');
		this.notificationList.innerHTML = notificationRenderData;
		const cards = SelectorEngine.find('.lta-notification-card', this._wrapper);
		for (const card of cards) {
			NotificationCard.getInstance(card) || new NotificationCard(card);
		}
	}

	renderNotificationRow(data) {
		return `<div class="lta-notification-card u-mb-2 u-text-grey-mid u-border u-rounded" data-redirect-url="${this.redirectUrl}?matchId=${data.matchId}">
			<div class="u-p-2 xl:u-p-3">
				<div class="u-mb-1 u-hstack lta-notification-card__inner">
					<div class="u-mr-2 u-text-lta-dark-blue">
						<span class="lta-tag lta-tag--warning u-caption3">${data.tagLabelPrefix} ${data.tagLabel}</span>
					</div>
					<div class="u-label2 u-text-lta-dark-blue">${data.date}</div>
				</div>
				<p class="u-h6 u-text-lta-dark-blue">${data.title}</p>
			</div>
		</div>`;
	}
}

const globalSelfSubmissionNotification = new SelfSubmissionNotification();
export default globalSelfSubmissionNotification;
